import { render, staticRenderFns } from "./BandejaRegresarEstatusPendienteComponente.vue?vue&type=template&id=5563ff1a"
import script from "./BandejaRegresarEstatusPendienteComponente.vue?vue&type=script&lang=js"
export * from "./BandejaRegresarEstatusPendienteComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports